"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REASONCIVICIMPERSONATION = exports.REASONCIVICMISINFORMATION = exports.REASONCIVICINTERFERENCE = exports.REASONCIVICDISCLOSURE = exports.REASONCIVICELECTORALPROCESS = exports.REASONRULEOTHER = exports.REASONRULEBANEVASION = exports.REASONRULEPROHIBITEDSALES = exports.REASONRULESTOLENCONTENT = exports.REASONRULESITESECURITY = exports.REASONMISLEADINGOTHER = exports.REASONMISLEADINGMISINFORMATION = exports.REASONMISLEADINGSYNTHETICCONTENT = exports.REASONMISLEADINGSCAM = exports.REASONMISLEADINGSPAM = exports.REASONMISLEADINGIMPERSONATION = exports.REASONMISLEADINGBOT = exports.REASONHARASSMENTOTHER = exports.REASONHARASSMENTDOXXING = exports.REASONHARASSMENTHATESPEECH = exports.REASONHARASSMENTTARGETED = exports.REASONHARASSMENTTROLL = exports.REASONCHILDSAFETYOTHER = exports.REASONCHILDSAFETYPROMOTION = exports.REASONCHILDSAFETYHARASSMENT = exports.REASONCHILDSAFETYENDANGERMENT = exports.REASONCHILDSAFETYMINORPRIVACY = exports.REASONCHILDSAFETYGROOM = exports.REASONCHILDSAFETYCSAM = exports.REASONSEXUALOTHER = exports.REASONSEXUALUNLABELED = exports.REASONSEXUALANIMAL = exports.REASONSEXUALDEEPFAKE = exports.REASONSEXUALSEXTORTION = exports.REASONSEXUALNCII = exports.REASONSEXUALABUSECONTENT = exports.REASONVIOLENCEOTHER = exports.REASONVIOLENCETRAFFICKING = exports.REASONVIOLENCEEXTREMISTCONTENT = exports.REASONVIOLENCEGLORIFICATION = exports.REASONVIOLENCESELFHARM = exports.REASONVIOLENCEGRAPHICCONTENT = exports.REASONVIOLENCETHREATS = exports.REASONVIOLENCEANIMALWELFARE = exports.REASONAPPEAL = void 0;
const lexicons_1 = require("../../../../lexicons");
const util_1 = require("../../../../util");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.report.defs';
/** Appeal a previously taken moderation action */
exports.REASONAPPEAL = `${id}#reasonAppeal`;
/** Animal welfare violations */
exports.REASONVIOLENCEANIMALWELFARE = `${id}#reasonViolenceAnimalWelfare`;
/** Threats or incitement */
exports.REASONVIOLENCETHREATS = `${id}#reasonViolenceThreats`;
/** Graphic violent content */
exports.REASONVIOLENCEGRAPHICCONTENT = `${id}#reasonViolenceGraphicContent`;
/** Self harm */
exports.REASONVIOLENCESELFHARM = `${id}#reasonViolenceSelfHarm`;
/** Glorification of violence */
exports.REASONVIOLENCEGLORIFICATION = `${id}#reasonViolenceGlorification`;
/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
exports.REASONVIOLENCEEXTREMISTCONTENT = `${id}#reasonViolenceExtremistContent`;
/** Human trafficking */
exports.REASONVIOLENCETRAFFICKING = `${id}#reasonViolenceTrafficking`;
/** Other violent content */
exports.REASONVIOLENCEOTHER = `${id}#reasonViolenceOther`;
/** Adult sexual abuse content */
exports.REASONSEXUALABUSECONTENT = `${id}#reasonSexualAbuseContent`;
/** Non-consensual intimate imagery */
exports.REASONSEXUALNCII = `${id}#reasonSexualNCII`;
/** Sextortion */
exports.REASONSEXUALSEXTORTION = `${id}#reasonSexualSextortion`;
/** Deepfake adult content */
exports.REASONSEXUALDEEPFAKE = `${id}#reasonSexualDeepfake`;
/** Animal sexual abuse */
exports.REASONSEXUALANIMAL = `${id}#reasonSexualAnimal`;
/** Unlabelled adult content */
exports.REASONSEXUALUNLABELED = `${id}#reasonSexualUnlabeled`;
/** Other sexual violence content */
exports.REASONSEXUALOTHER = `${id}#reasonSexualOther`;
/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
exports.REASONCHILDSAFETYCSAM = `${id}#reasonChildSafetyCSAM`;
/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
exports.REASONCHILDSAFETYGROOM = `${id}#reasonChildSafetyGroom`;
/** Privacy violation involving a minor */
exports.REASONCHILDSAFETYMINORPRIVACY = `${id}#reasonChildSafetyMinorPrivacy`;
/** Child endangerment. These reports will be sent only be sent to the application's Moderation Authority. */
exports.REASONCHILDSAFETYENDANGERMENT = `${id}#reasonChildSafetyEndangerment`;
/** Harassment or bullying of minors */
exports.REASONCHILDSAFETYHARASSMENT = `${id}#reasonChildSafetyHarassment`;
/** Promotion of child exploitation. These reports will be sent only be sent to the application's Moderation Authority. */
exports.REASONCHILDSAFETYPROMOTION = `${id}#reasonChildSafetyPromotion`;
/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
exports.REASONCHILDSAFETYOTHER = `${id}#reasonChildSafetyOther`;
/** Trolling */
exports.REASONHARASSMENTTROLL = `${id}#reasonHarassmentTroll`;
/** Targeted harassment */
exports.REASONHARASSMENTTARGETED = `${id}#reasonHarassmentTargeted`;
/** Hate speech */
exports.REASONHARASSMENTHATESPEECH = `${id}#reasonHarassmentHateSpeech`;
/** Doxxing */
exports.REASONHARASSMENTDOXXING = `${id}#reasonHarassmentDoxxing`;
/** Other harassing or hateful content */
exports.REASONHARASSMENTOTHER = `${id}#reasonHarassmentOther`;
/** Fake account or bot */
exports.REASONMISLEADINGBOT = `${id}#reasonMisleadingBot`;
/** Impersonation */
exports.REASONMISLEADINGIMPERSONATION = `${id}#reasonMisleadingImpersonation`;
/** Spam */
exports.REASONMISLEADINGSPAM = `${id}#reasonMisleadingSpam`;
/** Scam */
exports.REASONMISLEADINGSCAM = `${id}#reasonMisleadingScam`;
/** Unlabelled gen-AI or synthetic content */
exports.REASONMISLEADINGSYNTHETICCONTENT = `${id}#reasonMisleadingSyntheticContent`;
/** Harmful false claims */
exports.REASONMISLEADINGMISINFORMATION = `${id}#reasonMisleadingMisinformation`;
/** Other misleading content */
exports.REASONMISLEADINGOTHER = `${id}#reasonMisleadingOther`;
/** Hacking or system attacks */
exports.REASONRULESITESECURITY = `${id}#reasonRuleSiteSecurity`;
/** Stolen content */
exports.REASONRULESTOLENCONTENT = `${id}#reasonRuleStolenContent`;
/** Promoting or selling prohibited items or services */
exports.REASONRULEPROHIBITEDSALES = `${id}#reasonRuleProhibitedSales`;
/** Banned user returning */
exports.REASONRULEBANEVASION = `${id}#reasonRuleBanEvasion`;
/** Other */
exports.REASONRULEOTHER = `${id}#reasonRuleOther`;
/** Electoral process violations */
exports.REASONCIVICELECTORALPROCESS = `${id}#reasonCivicElectoralProcess`;
/** Disclosure & transparency violations */
exports.REASONCIVICDISCLOSURE = `${id}#reasonCivicDisclosure`;
/** Voter intimidation or interference */
exports.REASONCIVICINTERFERENCE = `${id}#reasonCivicInterference`;
/** Election misinformation */
exports.REASONCIVICMISINFORMATION = `${id}#reasonCivicMisinformation`;
/** Impersonation of electoral officials/entities */
exports.REASONCIVICIMPERSONATION = `${id}#reasonCivicImpersonation`;
//# sourceMappingURL=defs.js.map